// @ts-ignore
import SystemFieldProto from '../../proto/system-field-proto'

// not an actual field yet, just a stub for board preferences

export default class ParentTaskField extends SystemFieldProto {

    constructor(entityType:any) {
        super(entityType)
        this.type = gd.const.fields.type.PARENT_TASK_ID
    }

    get sortHintMessage() {
        return 'Sort by Parent Task'
    }

    getCsvValue(item:any) {
        return item.parentTaskShortId
    }

    getValue(item:any) {
        return item.checklist
    }
}
